import React, { FC } from 'react';
import { Header } from './Header';
import { ApplicantCounts } from './ApplicantCounts';
import { OpeningProps } from './props';
import './styles.scss';

export const Opening: FC<OpeningProps> = ({ opening, onUpdateOpening }) => {
  const recommended = opening.recommendedUsers.pagination.totalCount;
  const totalUnanswered = opening.pendingApplicants.pagination.totalCount;
  const totalMessaged = opening.inConversationApplicants.pagination.totalCount;
  const totalShortlist = opening.shortlistApplicants.pagination.totalCount;
  const unreadInConversation = opening.unreadInConversationApplicants.pagination.totalCount;
  const unreadShortlistApplicants = opening.unreadShortlistApplicants.pagination.totalCount || 0;

  return (
    <div className="opening-dashboard-item">
      <Header onUpdateOpening={onUpdateOpening} opening={opening} />

      {(!!recommended || !!totalUnanswered || !!totalMessaged || !!totalShortlist) && (
        <ApplicantCounts
          inConversation={totalMessaged}
          openingId={opening.id}
          pending={totalUnanswered}
          recommended={recommended}
          totalShortlist={totalShortlist}
          unreadInConversation={unreadInConversation}
          unreadShortlistApplicants={unreadShortlistApplicants}
        />
      )}
    </div>
  );
};
